/**
 * 线索相关
 * @author tylerzzheng
 */
import { IOrgGroup, IStaff } from './organazition'
import { BlackListTypeEnum } from './customer'
import { PublicTags, PrivateTags, Pagination, ISortOrder, AsyncTotal } from './common'
import { IndicatorFilter } from '@types'

/**
 * 客户来源标签对象 一级和二级
 */
interface SourceSecondTag {
  sourceId: number,
  sourceName: string,
}
export interface SourceTag {
  sourceId: number,
  sourceName: string,
  subSource: SourceSecondTag[],
}
/**
 * 触达状态过滤条件
 */
export interface TouchStatusFilter {
  intentionId: number
}
/**
 * 触达状态对象
 */
export interface TouchStatus {
  key: number,
  value: string,
}

/**
 * 线索意向等级
 */
export interface LeadIntentionLevel {
  code: string
  name: string
  child: {
    code: string
    name: string
  }[]
}

export interface GetAddLeadCustomerFollower {
  follower: IStaff,
  isFollowed: IsFollowedEnum,
}

export enum IsFollowedEnum {
  YES = 1, // 有跟进人
  NO = 0, // 无跟进人
}

/**
 * 添加线索上送对象
 */
export interface NewLead {
  contributor: string // 线索贡献人
  name: string // 客户名称
  smallProduct?: string // 关注产品一级
  subProduct?: string // 关注产品二级
  uin: string // uin
  phone?: string // 电话
  intentionLevel?: string // 意向等级一级
  intentionSecondLevel?: string // 意向等级二级
  leadTags?: string [] // 线索标签
  primaryIndustryIncomeName?: string // 磐石一级行业名称
  provinceCode?: string // 省份code
  cityCode?: string // 市code
  mainBusiness?: string // 主营业务
  companySize?: string // 公司规模
  customerDemand?: string // 客户需求
  selectionReason?: string // 入选原因
  email?: string // 邮箱
  wechat?: string // 微信
  job?: string // 职位
  contactName?: string // 联系人
  assignFollower?: string // 指定跟进人
  // extend?: Array<ExtendItem>
  customTrackId?: string //  自定义标识ID
}

/* 线索的两种查询方式，默认通过es，优点是速度快，缺点是会缓存。 如果是更新操作之后立即查询， 需要传after-update */
export enum LeadPoolQueryTypeEnum {
  DEFAULT = 'default',
  AFTER_UPDATE = 'after-update',
}

/**
 * 线索池过滤对象
 */
export interface LeadPoolFilter extends Pagination, ISortOrder, AsyncTotal {
  queryType?: LeadPoolQueryTypeEnum // 线索的两种查询方式，默认通过es，优点是速度快，缺点是会缓存。 如果是更新操作之后立即查询， 需要传after-update
  status?: LeadStatusEnum[] | LeadStatusEnum
  leadId?: number // 线索ID
  leadName?: string // 线索名称 注意和客户名称区分。线索名称是新增线索时候，带的客户名称。客户名称是真实查询的磐石的客户名称
  name?: string // 客户名称
  customerId?: number // 客户ID
  touchStatus?: number[] // 触达状态
  intentionId?: number[] // 一级客户意向ID
  subIntentionId?: number[] // 二级客户意向ID
  ruleType?: number // 任务类型
  sourcePrimaryTagId?: number // 一级客户来源
  sourceSecondaryTagId?: number // 二级客户来源
  groupId?: number // 所属业务组
  follower?: string | string[] // 当前跟进人 当值为空的时候(空字符串"",或数组里包含一个字符串[""])表示筛选没有跟进人的线索
  leadBeginTime?: string // 线索创建开始时间（格式为2020-04-17 16:46:45）
  leadEndTime?: string // 线索创建结束时间（格式为2020-04-17 16:46:45）
  publicTagId?: number | number[] // 公共标签
  privateTagId?: number | number[] // 个人标签
  leadAssignTimeFrom?: string // 线索变更时间开始时间（格式为2020-04-17 16:46:45）
  leadAssignTime?: string // 线索变更时间时间（格式为2020-04-17 16:46:45）
  abandonBeginTime?: string // 废弃开始时间（格式为2020-04-17 16:46:45）
  abandonEndTime?: string // 废弃结束时间（格式为2020-04-17 16:46:45）
  regTimeFrom?: string // 注册时间范围开始（格式为2020-04-17 16:46:45）
  regTimeTo?: string // 注册时间范围结束（格式为2020-04-17 16:46:45）
  authTimeFrom?: string // 认证时间范围开始（格式为2020-04-17 16:46:45）
  authTimeTo?: string // 认证时间范围结束（格式为2020-04-17 16:46:45）
  qq?: string // qq
  phone?: string // 电话
  uin?: string | string[] // uin
  extend?: string // 其它信息
  batchId?: number | number[] // 批次ID
  payType?: PayTypeEnum | PayTypeEnum[] // 付费类型1=未付费未使用2=未付费已使用3=已付费
  // intentionLevel?: IntentionLevelEnum // 意向度H=高M=中L=低
  intentionLevel?: string // 意向等级一级
  intentionSecondLevel?: string // 意向等级二级
  smallProduct?: string // 关注产品一级
  subProduct?: string // 关注产品二级
  leadTags?: string[] // 是 string 线索标签
  sort?: 'leadCreateTime' | 'leadAssignTime'
  leadStatus?: LeadStatusEnum // 线索状态
  exceedSla?: LeadExceedSlaEnum // int 否 是否超SLA，1-是，0-否
  exceedPeriod?: LeadExceedPeriodEnum // Int 否 是否失效，1-是，0-否
  firstAssignTimeFrom?: string // 首次分配开始时间
  firstAssignTimeTo?: string // 首次分配结束时间
  firstAssigner?: string // 首次分配人
  firstFollowTimeFrom?: string // 首次跟进开始时间
  firstFollowTimeTo?: string // 首次跟进结束时间
  firstFollower?: string // 首次跟进人
  leadReleaseSourceId?: string // 来源方线索ID
  provinceCode?: string, // 省市,
  cityCode?: string, // 省市
  leadIds?: number[] // 线索ID
}

/**
 * 更新线索筛选项的上送参数
 */
export interface UpdateLeadsFilter {
  filter: Omit<LeadPoolFilter, keyof (Pagination & ISortOrder)> & {
    leadIds?: number[]
  }
  updateResult: {
    status?: number
    updateLeadPublicTags?: {
      publicTagIds?: number[] // 公共标签id
    }
    updateLeadPrivateTags?: {
      privateTagIds?: number[] // 个人标签id
    }
  }
}

export enum AssignToOfflineSales {
  NO,
  YES

}
/**
 * 手动分配线索筛选项的上送参数
 */
export interface AssignLeadsFilter {
  filter: Omit<LeadPoolFilter, keyof (Pagination & ISortOrder)> & {
    leadIds?: number[]
  }
  taskName: string, // 任务名称
  salesNames: string[]
  ifAssignToOfflineSales: AssignToOfflineSales
  assignRemark?: string
  extraFormId?: number
}

/**
 * @deprecated 已废弃
 * 手回收线索的上送参数
 */
export interface ReuseLeadFilter {
  salesNames: string[] // 销售名，为空数组时回收到公海池，每个销售名不能为空
  leadIds: number[] // 待回收线索ID数组
  ifAssignToOfflineSales?: AssignToOfflineSales // 是否派发给离线销售0否1是，回收至指定人时必选
  taskName?: string, // 任务名称 // salesNames为空时没有任务名称（即回收到公海池）
}

export interface Extend {
  key: string,
  keyValue: string,
  keyName: string,
}

/**
 * 线索池对象
 */
export interface ILeadPoolItem {
  leadId: number,
  leadExtend: Extend[],
  taskCreateTime: string,
  authTime: string, // 认证时间
  regTime: string, // 注册时间
  customerId: string,
  name: string, // 客户名称 注意和leadName区分开
  leadName: string, // 线索名称
  uin: string,
  sourcePrimaryTagId: number,
  sourcePrimaryTagName: string,
  sourceSecondaryTagId: number,
  sourceSecondaryTagName: string,
  publicTags: PublicTags[]
  privateTags: PrivateTags[]
  leadStatus: LeadStatusEnum,
  touchStatus: number,
  follower: string,
  intentionId: number,
  intentionName: string,
  subIntentionId: number,
  subIntentionName: string,
  position: string, // 职业 行业 职位 （接口文档，页码，原型图的各种叫法）
  provinceCode: string,
  cityCode: string,
  groups: IOrgGroup[]
  leadCreateTime: string,
  lastFollowCreateTime: string,
  leadAssignTime: string,
  phone: string
  blackListType: BlackListTypeEnum // 是否在黑名单中
  wechat: string
  email: string
  qq: string
  cid: string
  ruleId: number // 规则ID  // 为0的时候任务不是自动分配的，是手动分配
  taskName: string // 任务类型 当手动分配的时候会有此项
  ruleName: string // 规则名
  // ruleType: string // 规则类型ID
  ruleTypeName: string // 规则类型名
  batchId: number // 批次id
  batchName: string // 批次名称
  extraFormId: number
  payType: PayTypeEnum // 付费类型1=未付费未使用2=未付费已使用3=已付费
  // intentionLevel: IntentionLevelEnum // 意向度H=高M=中L=低
  customerType: number// 客户类型
  authState: number // 认证状态
  leadReleaseSourceId: string // 来源方线索ID
  firstAssignTime: string // 首次分配时间
  firstAssigner: string // 首次分配人
  firstFollowTime: string // 首次跟进时间
  firstFollower: string// 首次跟进人
  leadTagNames: string[] // 线索标签
  subProductName: string // 行业产品子类名称
  smallProductName: string // 行业产品细类名称
  intentionLevelName: string // 意向等级一级
  intentionSecondLevelName: string // 意向等级二级
  primaryIndustryIncomeId: number // 行业
  primaryIndustryIncomeName: string //
  exceedSla: LeadExceedSlaEnum // int 否 是否超SLA，1-是，0-否
  exceedPeriod: LeadExceedPeriodEnum // Int 否 是否失效，1-是，0-否
  leadSlaTime: string // timestamp 否 线索sla时间
  leadPeriodTime: string // timestamp 否 线索过期时间
  status: number // 线索状态
}

// 线索状态枚举、映射
export enum LeadStatusEnum {
  UNHANDLE = 0,
  ASSIGNED,
  DISCARDED,
  FOLLOWED,
}

// 线索是否超SLA，1-是，0-否
export enum LeadExceedSlaEnum {
  NO = 0,
  YES = 1,
}

// 线索是否失效，1-是，0-否
export enum LeadExceedPeriodEnum {
  NO = 0,
  YES = 1,
}

// 付费类型枚举
export enum PayTypeEnum {
  // 1=未付费未使用
  UNPAID_UNUSED = 1,
  // 2=未付费已使用
  UNPAID_USED = 2,
  // 3=已付费
  PAID = 3,
}

// 意向度枚举
// export enum IntentionLevelEnum {
//   // 高
//   H = 'H',
//   // 中
//   M = 'M',
//   // 低
//   L = 'L'
// }

/**
 * @deprecated 已废弃
 */
export interface AddLeadBatchFilter {
  leads?: AddLeadBatch[]
}

/**
 * @deprecated 已废弃
 */
export interface FailLeadData {
  uin: string// "353553464674334",
  name: string// "测试分配线索公司29",
  code: number// 603014,
  index: number// 行数,
  message: string// "通过uin查找客户信息为空"
}

/**
 * 批量上传线索扩展参数字段
 * @deprecated 已废弃
 */
export interface ExtendType {
  key: string
  keyName: string
  keyValue: string
}

/**
 * 批量上传线索参数
 * @deprecated 已废弃
 */
export interface AddLeadBatch {
  contributor: string
  sourcePrimaryTagId: string
  sourceSecondaryTagId: string
  qq?: string
  phone?: string
  name?: string
  email?: string
  publicTagIds?: number[]
  privateTagIds?: number[]
  extend?: ExtendType[]
  intentionId: string
  touchStatus?: string
  wechat?: string
}

/* 分配方式 */
export enum AssignType {
  ALL = 'all', // 全部座席
  CERTAIN = 'certain', // 指定座席
}

/**
 * 线索标签
 */
export interface LeadTagsItem {
  id: number,
  tagCode: string,
  tagName: string,
  createtime: string,
  lastUpdateTime: string,
  creator: string,
  updator: string,
}

/**
 * 线索流转项类型定义
 */
export interface LeadTransferItem {
  id: number;
  cid: string;
  customerName: string;
  customerType: number;
  district: string;
  province: string;
  city: string;
  industry: string;
  intentionLevel: string;
  intentionSecondLevel: string;
  salesChannel: string;
  salesChannelName: string;
  needProduct1: string;
  needProduct2: string;
  needProductName1: string;
  needProductName2: string;
  nameSales: string;
  expectBuyDate: string;
  registeredCapital: number;
  memberScale: string;
  monthConsumption: string;
  position: string;
  businessDemand: string;
  selectionReason: string;
  cloudVendorUse: string[];
  contactName: string;
  contactPhone: string;
  contactPosition: string;
  leadSource: number;
  origLeadId: number;
  createTime: string;
  transferTime: string;
  status: number; // 0 待流转 1 流转中 2 流转成功 3 流转失败 4 已打回
  transferChannel: string;
  intentionLevelName: string;
  intentionSecondLevelName: string;
  origLeadInfo: OrigLeadInfo;
  leadTags: string[];
  batchId: number;
  batchName: string;
  transferSalesName: string;
  follower: string;
  firstIncomeIndustryName: string;
  leadId: number;
  customerId: number;
}

/**
 * 待转出意向线索列表过滤条件
 */
export interface LeadTransferListFilter extends Pagination, ISortOrder, AsyncTotal {
  leadId?: number;
  leadSource?: number;
  origCustomerName?: string;
  province?: string;
  city?: string;
  industry?: string;
  registeredCapital?: string;
  needProduct1?: string;
  needProduct2?: string;
  salesChannel?: string;
  createTimeFrom?: string;
  createTimeTo?: string;
  batchId?: number[];
  follower?: string[];
  statusList?: number[];
}

/**
 * 跟进记录
 */
export interface FollowRecord {
  followRecordId: number;
  sameFollowId: number;
  creator: string;
  follower: string;
  createTime: string;
  updateTime: string;
  communicateResult: string;
  remark: string;
  followType: string[];
  leadIds: string;
  taskIds: string;
  belongModule: number;
  cid: string;
  customerId: number;
  customerName: string;
  extend: Extend[];
  intention: string;
  intentionId: number;
  intentionName: string;
  subIntentionId: number;
  subIntentionName: string;
  interestSmallProduct: string;
  interestSmallProductName: string;
  interestSubProduct: string;
  interestSubProductName: string;
  nextFollowTime: string;
  touchCustomer: number;
  touchIssue: number;
  touchIssueCh: string;
  touchIssueDetail: string;
}

/**
 * 线索意向和待孵化项类型定义
 */
export interface LeadIntentionAndPipelineItem {
  leadId: number;
  leadName: string;
  customerId: number;
  name: string;
  cid: string;
  contactId: number;
  contactName: string;
  contactPosition: string;
  follower: string;
  followTime: string;
  followContent: string;
  intentionId: number;
  intentionName: string;
  subIntentionId: number;
  subIntentionName: string;
  interestSmallProduct: string;
  interestSmallProductName: string;
  interestSubProduct: string;
  interestSubProductName: string;
  taskId: number;
  taskName: string;
  taskCreateTime: string;
  batchId: number;
  batchName: string;
  leadExtend: Extend[];
  followRecord: FollowRecord;
}

/**
 * 线索意向和待孵化列表过滤条件
 */
export interface LeadIntentionAndPipelineListFilter extends Pagination, ISortOrder, AsyncTotal {
  taskId?: number;
  customerName?: string;
  taskName?: string;
  taskCreateTimeFrom?: string;
  taskCreateTimeTo?: string;
  createTimeFrom?: string;
  createTimeTo?: string;
  status?: number; // 4 意向线索 5 待孵化线索
  batchId?: number[];
}

/**
 * 线索意向和待孵化列表过滤条件
 */
export interface LeadIntentionAndPipelineByTagListFilter extends LeadIntentionAndPipelineListFilter, IndicatorFilter {
  tag?: string;
}

/**
 * 原始线索信息类型定义
 */

/** leadExtend 数组中的对象类型 */
interface LeadExtendItem {
  /** 键名 */
  key: string
  /** 键显示名称 */
  keyName: string
  /** 键值 */
  keyValue: string
}

/** 原始线索信息 */
export interface OrigLeadInfo {
  /** 指派跟进人 */
  assignFollower: string
  /** 授权状态 */
  authState: number
  /** 授权时间 */
  authTime: string
  /** 批次ID */
  batchId: number
  /** 批次名称 */
  batchName: string
  /** 黑名单类型 */
  blackListType: number
  /** 客户ID标识 */
  cid: string
  /** 城市编码 */
  cityCode: string
  /** 客户ID */
  customerId: number
  /** 客户状态 */
  customerStatus: number
  /** 客户类型 */
  customerType: number
  /** 描述 */
  desc: string
  /** 邮箱 */
  email: string
  /** 超期天数 */
  exceedPeriod: number
  /** 超期SLA */
  exceedSla: number
  /** 扩展信息（JSON字符串） */
  extend: string
  /** 额外表单ID */
  extraFormId: number
  /** 首次分配时间 */
  firstAssignTime: string
  /** 首次分配人 */
  firstAssigner: string
  /** 首次跟进时间 */
  firstFollowTime: string
  /** 首次跟进人 */
  firstFollower: string
  /** 跟进人 */
  follower: string
  /** 组名 */
  groupName: string
  /** 组列表 */
  groups: any[]
  /** 意向ID */
  intentionId: number
  /** 意向等级 */
  intentionLevel: string
  /** 意向等级名称 */
  intentionLevelName: string
  /** 意向名称 */
  intentionName: string
  /** 意向二级等级 */
  intentionSecondLevel: string
  /** 意向二级等级名称 */
  intentionSecondLevelName: string
  /** 最后跟进时间 */
  lastFollowTime: string
  /** 线索分配时间 */
  leadAssignTime: string
  /** 线索创建时间 */
  leadCreateTime: string
  /** 线索扩展信息 */
  leadExtend: LeadExtendItem[]
  /** 线索ID */
  leadId: number
  /** 线索名称 */
  leadName: string
  /** 线索有效期时间 */
  leadPeriodTime: string
  /** 线索释放来源 */
  leadReleaseSource: string
  /** 线索释放来源ID */
  leadReleaseSourceId: string
  /** 线索SLA时间 */
  leadSlaTime: string
  /** 线索状态 */
  leadStatus: number
  /** 线索标签名称列表 */
  leadTagNames: string[]
  /** 线索标签 */
  leadTags: string
  /** 名称 */
  name: string
  /** 付费类型 */
  payType: number
  /** 电话 */
  phone: string
  /** 主营行业收入ID */
  primaryIndustryIncomeId: number
  /** 主营行业收入名称 */
  primaryIndustryIncomeName: string
  /** 私有标签ID */
  privateTagIds: string
  /** 私有标签列表 */
  privateTags: any[]
  /** 省份编码 */
  provinceCode: string
  /** 公有标签ID */
  publicTagIds: string
  /** 公有标签列表 */
  publicTags: any[]
  /** QQ */
  qq: string
  /** 注册时间 */
  regTime: string
  /** 规则ID */
  ruleId: number
  /** 规则名称 */
  ruleName: string
  /** 规则类型名称 */
  ruleTypeName: string
  /** 小产品 */
  smallProduct: string
  /** 小产品名称 */
  smallProductName: string
  /** 来源主标签ID */
  sourcePrimaryTagId: number
  /** 来源主标签名称 */
  sourcePrimaryTagName: string
  /** 来源次级标签ID */
  sourceSecondaryTagId: number
  /** 来源次级标签名称 */
  sourceSecondaryTagName: string
  /** 状态 */
  status: number
  /** 子意向ID */
  subIntentionId: number
  /** 子意向名称 */
  subIntentionName: string
  /** 子产品 */
  subProduct: string
  /** 子产品名称 */
  subProductName: string
  /** 标签ID */
  tagIds: string
  /** 任务ID */
  taskId: number
  /** 任务名称 */
  taskName: string
  /** 触达状态 */
  touchStatus: number
  /** 用户标识 */
  uin: string
  /** 微信 */
  wechat: string
}
